import { useEffect } from 'react';

export const useScrollAreaIntersection = (anchorElement: HTMLElement | null,
    callback: (isIntersecting: boolean) => void,
    watch: boolean,
    viewportMargin?: string
) => {

    const observers: Array<IntersectionObserver> = [];

    const elements = Array.from(document.querySelectorAll('[data-scroll-area]'));

    const observerCallback = (entries: Array<IntersectionObserverEntry>) => {
        for (const entry of entries) {
            if (callback) {
                callback(entry.isIntersecting);
            }
        }
    };

    for (const element of elements) {
        if (element.contains(anchorElement)) {
            observers.push(new IntersectionObserver(observerCallback,
                {
                    root: element,
                    rootMargin: element.getAttribute('data-scroll-area') || '0px',
                    threshold: 1
                }));
        }
    }

    if (viewportMargin) {
        observers.push(new IntersectionObserver(observerCallback,
            {
                root: null,
                rootMargin: viewportMargin,
                threshold: 1
            }));
    }

    useEffect(() => {
        if (anchorElement) {
            if (watch) {
                observers.forEach(observer => observer.observe(anchorElement));
            } else {
                observers.forEach(observer => observer.unobserve(anchorElement));
            }
        }
    }, [ watch, anchorElement ]);
};

export default useScrollAreaIntersection;
